import CampSessionGroupIndex from './CampSessionGroupIndex';
import CampSessionGroupCreate from './CampSessionGroupCreate';
import CampSessionGroupSettings from './CampSessionGroupSettings';
import CampSessionGroupSingle from './CampSessionGroupSingle';

export default function (app) {

    const settings = CampSessionGroupSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 11,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    CampSessionGroupIndex(app, settings);

    CampSessionGroupCreate(app, settings);

    CampSessionGroupSingle(app, settings);

}